import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

function HomeGiftBoxComponent() {
  const APIURL = process.env.REACT_APP_API_URL;
  const [product, setProductData] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const navigate = useNavigate();
  const categoryType = "Gift Boxes";

  /* ✅ IMAGE HELPER (OLD + NEW JSON SUPPORT) */
  const getImageByIndex = (images = [], index = 0) => {
    if (!images || !images[index]) return "";

    // New format: { url, tags }
    if (typeof images[index] === "object") {
      return images[index].url;
    }

    // Old format: string
    return images[index];
  };

  const getProducts = async () => {
    try {
      const response = await fetch(
        `${APIURL}/api/service/products/category?category=${categoryType}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      setProductData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="homegift-box-component-bg">
      <div className="homegift-box-component-main">
        <div className="homegift-box-component-heading-row">
          <div>GiftBox</div>

          <div className="home-gift-box-componenet-view-all-btn">
            <Link to="/collection/giftbox">
              <div>View All</div>
            </Link>
          </div>
        </div>

        <div>
          <div className="home-gift-product-list-rows">
            {product?.data?.slice(0, 5).map((e, i) => (
              <div
                className="home-gift-product-list-cols"
                key={e._id}
              >
                <div
                  className="home-gift-product-list-cols-img-cont"
                  onClick={() => navigate(`/product/${e._id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={
                      hoveredIndex === i
                        ? getImageByIndex(e.images, 1) ||
                          getImageByIndex(e.images, 0)
                        : getImageByIndex(e.images, 0)
                    }
                    alt={e.fullName}
                    onMouseEnter={() => setHoveredIndex(i)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  />
                </div>

                <div className="home-gift-product-text-heading">
                  {e.fullName?.split(" ").slice(0, 3).join(" ")}
                  {e.fullName?.split(" ").length > 4 && " ..."}
                </div>

                <p className="cols-price-text">
                  <span>Rs. {e.mainPrice}</span>
                  <span> Rs. {e.price}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeGiftBoxComponent;
